import Vue from 'vue'
import Vuex from 'vuex'
import md5 from 'md5'
import axios from 'axios'
import sha512 from 'js-sha512'
import cookies from 'vue-cookie'



Vue.use(Vuex)

const actions = {
  login ({commit}, data) {
    return new Promise(function (resolve, reject) {
      var password = sha512(md5(data.pass))
      var credentials = {
        password: password,
        login: data.login
      }
      axios.post('/api/auth/login', credentials).then(function(response) {
        if (response.status === 200) {
          commit('LOGIN_SUCCESS')
          resolve()
        } else {
          reject(Error('wrong login or password'))
        }
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  logout ({commit}) {
    return new Promise(resolve => {
      cookies.delete('session')
      commit('LOGOUT')
      resolve()
    })
  }
}

const state = {
  place: '',
  places: {},
  isLoading: false,
  logged: false,
  item: {
    edited: false,
    index: null,
    content: {}
  }
}
const mutations = {
  choosePlace (state, place) {
    state.place = place
  },
  setPlaces (state, places) {
    state.places = places
  },
  setLoading (state, loading) {
    state.isLoading = loading
  },
  LOGIN_SUCCESS (state) {
    state.logged = true
  },
  LOGOUT (state) {
    state.logged = false
  },
  EDIT_ITEM (state, data) {
    state.item.edited = data.edited
    state.item.index = data.index
    state.item.content = data.item
  }
}
const getters = {
  place(state) {
    state => state.place
  },
  isLoading: state => state.isLoading,

  checkIfLogged: () => {
    if (cookies.get('session') !== null) {
      store.commit('LOGIN_SUCCESS')
      return true
    } else {
      return false
    }
  },
  isLogged: (state, getters) => {
    if (state.logged) {
      return true
    } else {
      if (getters.checkIfLogged) {
        return true
      } else {
        return false
      }
    }
  }
}
const store = new Vuex.Store ({
  actions,
  mutations,
  state,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js